/** Explicit server evidence only; transport and review failures do not create this state. */
import type { KapazitaetsAufbereitung } from '../../shared/guide-kapazitaets-aufbereitung';

export function GuideKapazitaetsAufbereitung({ stand }: { stand?: KapazitaetsAufbereitung | null }) {
  if (!stand || stand.stand === 'fortgesetzt') return null;
  const titel = {
    ausstehend: 'Account nicht verfügbar – Aufbereitung ausstehend',
    laeuft: 'Account nicht verfügbar – Aufbereitung läuft',
    bereit: 'Stand aufbereitet – Fortsetzung wartet auf verfügbaren Account',
    blockiert: 'Account nicht verfügbar – Aufbereitung unterbrochen',
  }[stand.stand];
  return <aside data-ai-id="guide-kapazitaets-aufbereitung" aria-label="Account und Fortsetzung"
    style={{ border: '1px solid var(--tn-orange, #b7791f)', borderLeftWidth: 4, borderRadius: 8, padding: '10px 12px', marginBottom: 12, fontSize: 12, lineHeight: 1.5 }}>
    <strong style={{ color: 'var(--tn-orange, #b7791f)' }}>{titel}</strong>
    <p style={{ margin: '6px 0' }}>{stand.naechsterSchritt}</p>
    <small>Account geprüft: <time dateTime={stand.blockadeGeprueftAm}>{new Date(stand.blockadeGeprueftAm).toLocaleString('de-AT')}</time></small>
    <details>
      <summary>Kapazitätsprüfung und Zuständigkeit</summary>
      <p>{stand.grund}</p>
      <dl style={{ overflowWrap: 'anywhere' }}>
        {stand.stand === 'bereit' && stand.fertigAm && <><dt>Stand aufbereitet</dt><dd><time dateTime={stand.fertigAm}>{stand.fertigAm}</time></dd></>}
        <dt>Berater für die Fortsetzung</dt><dd>{stand.originalBerater}</dd>
        {stand.aufbereiter && <><dt>Begrenzte Aufbereitung</dt><dd>{stand.aufbereiter}</dd></>}
      </dl>
      {stand.beleg && <p style={{ overflowWrap: 'anywhere' }}>{stand.beleg}</p>}
    </details>
  </aside>;
}
